import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=45b6542e&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=ts&"
export * from "./taskDetail.vue?vue&type=script&lang=ts&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=45b6542e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b6542e",
  null
  
)

export default component.exports